import React from 'react';

import {
  EMAIL,
  PHONE,
  DATE_OF_BIRTH,
  ADDRESS,
  DEFAULT_EMAIL,
  DEFAULT_NUMBER,
  DEFAULT_DOB,
  STREET_ADDRESS,
  CITY,
  STATE,
  ZIP_CODE,
  APT_UNIT,
} from '../../constants/Profile';
import './UserProfileView.css';

export const UserProfileView = ({ user = {}, userAddress = {} }) => {
  const formatPhone = (phone) => {
    if (!phone) return '';
    const cleaned = ('' + phone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return phone;
  };

  const formatDateOfBirth = (date) => {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    if (year && month && day) {
      return `${month}/${day}/${year}`;
    }
    return date;
  };
  const addressDisplay = `${userAddress?.[STREET_ADDRESS]} ${userAddress?.[APT_UNIT] ? 'Apt. ' + userAddress?.[APT_UNIT] : ''}`;
  const cityDisplay = `${userAddress?.[CITY]}, ${userAddress?.[STATE]}. ${userAddress?.[ZIP_CODE]}`;

  return (
    <div>
      <div className="profile-view-row">
        <div>{EMAIL}</div>
        <div>{user.email || DEFAULT_EMAIL}</div>
      </div>
      <div className="profile-view-row">
        <div>{PHONE}</div>
        <div>{formatPhone(user.phone) || DEFAULT_NUMBER}</div>
      </div>
      <div className="profile-view-row">
        <div>{DATE_OF_BIRTH}</div>
        <div>{formatDateOfBirth(user.birthdate) || DEFAULT_DOB}</div>
      </div>
      <div className="profile-view-row">
        <div>{ADDRESS}</div>
        <div className="profile-address">
          <div>{addressDisplay} </div>
          <div>{cityDisplay} </div>
        </div>
      </div>
    </div>
  );
};
